import React, { Component } from 'react';
import Radium from 'radium';
import MultiChoiceResponse from './MultiChoiceResponse';
import SingleChoiceResponse from './SingleChoiceResponse';
import * as Colors from '../../../../helper/Colors';

const kTickerFontSize = 12.0;
const kQuestionNumberTextMargin = 8.0;
const kMarginBig = 16.0;
const kMarginSmall = 8.0;

/* prop types :
 *  position => question no. in list of questions of quizcard
 *  question => proper question object with txt, options etc.
 *  submission => text encoded answer like {1,2,3} or '4' etc.
 *  uploadResponse => function forwarded to do PostSubmissionMutation
 */
@Radium
class QuestionItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <div style={styles.innerContainer}>{this.renderAnswerComponent()}</div>;
  }

  renderAnswerComponent() {
    switch (this.props.rType) {
      case 'SINGLE_SELECT':
        return (
          <SingleChoiceResponse
            options={this.props.submissionObj.options}
            submission={this.props.submission}
            uploadResponse={this.props.uploadResponse}
            isEnrolled={this.props.isEnrolled}
            selectOption={this.props.selectOption}
            actualSubmit={this.props.actualSubmit}
            subType={this.props.subType}
          />
        );
      case 'MULTIPLE_SELECT':
        return (
          <MultiChoiceResponse
            options={this.props.submissionObj.options}
            submission={this.props.submission}
            uploadResponse={this.props.uploadResponse}
            isEnrolled={this.props.isEnrolled}
            selectOption={this.props.selectOption}
            actualSubmit={this.props.actualSubmit}
            subType={this.props.subType}
          />
        );
      default:
        console.log('rType: ', this.props.submission.answerType);
        throw new Error('Invalid response type');
        break;
    }
  }
}

const styles = {
  innerContainer: {
    // position:'relative',
    flex: 1,
    // paddingTop : '50px',
    paddingBottom: kMarginBig
    // overflow: 'hidden',
    // marginRight:'32px',
    // marginLeft:'30px',
    // maxWidth:'762px',
    // minWidth:500,
  },
  tickerStyle: {
    position: 'absolute',
    // top: 0,
    // right: -32,
    right: '0px',
    top: '20px'
  },
  choiceOption: {
    display: 'flex',
    // width: '168px',
    // height: '36px',
    borderRadius: '2px',
    backgroundColor: 'rgba(56,197,242,0.12)',
    justifyContent: 'center',
    alignItems: 'center',
    borderLeftTopRadius: '4px',
    borderLeftBottomRadius: '4px',
    padding: '8px 14px'
  },
  optionText: {
    fontWeight: '500',
    fontSize: '11px',
    textTransform: 'uppercase',
    color: '#767e86'
  },
  separator: {
    backgroundColor: 'black',
    opacity: 0.12,
    height: 1,
    alignSelf: 'stretch'
  },
  choiceHint: {
    alignSelf: 'center',
    backgroundColor: Colors.optionSelectedColor,
    borderTopLeftRadius: 2,
    borderBottomLeftRadius: 2
  },
  choiceHintLabel: {
    fontSize: kTickerFontSize,
    margin: kMarginSmall
  },
  row: {
    paddingLeft: kMarginBig,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  questionNumber: {
    opacity: 0.54,
    alignSelf: 'center'
  },
  questionText: {
    opacity: 0.87
  },
  marginoffset: {
    marginBottom: kQuestionNumberTextMargin
  },
  htmlQuestionWrapper: {
    // paddingLeft: kMarginBig,
    // paddingRight: kMarginBig
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.9)',
    marginBottom: '22px'
  },
  mainFont: {
    opacity: '0.4',
    marginTop: '31px',
    marginBottom: '20px',
    fontWeight: '500',
    fontSize: '12px',
    color: '#000000'
  }
};

module.exports = QuestionItem;
